import { RectangleCircle } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RectangleCircleIcon = createLucideIcon(RectangleCircle);
